import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from "@angular/core";
import { PdfDownloadService } from "../service/pdf-download.service";
import { takeUntil } from 'rxjs/operators';
import { SelectItem } from "primeng/api";
import { MessageService } from "primeng/api";
import { ConfirmationService } from "primeng/api";
import { MenuItem } from "primeng/api";
import * as pdfMake from "pdfmake/build/pdfmake";
import { Observable, Subject} from "rxjs";
import { Observer } from "rxjs/Rx";

import { DatePipe } from "@angular/common";
import { IssoUtilService } from "src/app/services/isso-util.service";
import { SgfiEntriesService } from "../service/sgfi-entries.service";
import { ReportMeritService } from "../service/report-merit.service";
import { environment } from "src/environments/environment";
import { SgfiEventsService, sportImage, longDate } from "../sgfi-events/sgfi-events.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer, SafeResourceUrl, SafeUrl } from "@angular/platform-browser";

@Component({
  selector: "app-sgfi-entries",
  templateUrl: "./sgfi-entries.component.html",
  styleUrls: ["./sgfi-entries.component.css"],
})
export class SgfiEntriesComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  isAddStudent: boolean;
  /** Set when this screen is one event's entries rather than a free search. */
  eventScoped = false;
  /** The picker's own search, so it does not fight the page's. */
  pickSearch = "";
  /* Editing the event itself, from the gear beside the title. */
  eventEditOpen = false;
  eventSaving = false;
  eventError = "";
  standardFee = "";
  // Everything about an event is editable except what identifies it: the
  // category and the season, which entries are already filed under.
  eventForm = { lastDate: "", reportingDate: "", venue: "", description: "", feeOverride: "" };
  private pickSearchTimer: any = null;
  event: any = null;
  eventTitle = "";
  isViewStudent: boolean;
  yearOptions: SelectItem[];
  gameOptions: SelectItem[];
  ageOptions: SelectItem[];
  genderOptions: SelectItem[];
  subgameOptions: SelectItem[];
  schoolOptions: SelectItem[];
  gameArray = [];
  getSchoolList = [];
  subGameIdArray = [];
  subGameNameArray = [];
  studentDataArray = [];
  sgfiStudentArray = [];
  saveSgfiStudentArray = [];
  gameServiceDATA: any;
  rootGameServicData: any;
  subGameServicData: any;
  rootGameData: any;
  subGameData: any;
  yearvalue: any;
  selectedGame: string;
  gameReadble: boolean;
  gameId: any;
  gameName: any;
  gameType: any;
  ageReadble: boolean;
  selectedAge: string;
  genderReadble: boolean;
  selectedGender: string;
  selectedSchool: string;
  genderVal: any;
  schoolReadble: boolean;
  selectedSubGame: string;
  subGameReadable: boolean;
  subgameArray = [];
  subGameId: any;
  subGameName: any;
  subGameType: any;
  schoolList: any;
  subGameVal: any;
  isShowStudent: boolean;
  studentData: any;
  schoolId: any;
  isDuplicate: boolean;
  error: any;
  alreadyAddedStudentList: any;
  studentRecordLength: number = 0;
  schoolName: any;
  selectedYear: string;
  enrolledStudentData: any;
  enrolledStudentRecordLength: number;
  alreadyExist: boolean;
  display: boolean;
  docArray: any;
  baseUrl: string;
  dialogTitle: any;
  isShowPayment: boolean;
  sgfiPaymentData: any;
  sgfiPaymentDataLength: any;
  gameconsolitedArray: any[];
  isPaymentData: boolean;
  // View Student paging - the unfiltered year is ~1,100 rows.
  pageSize = 25;
  currentPage = 1;
  totalRecords = 0;
  totalPages = 0;
  isLoading = false;
  // Picking lists: merit holders and event participants on the left (tabs), SGFI entries on the right.
  meritSides = ["merit", "participants", "added"];
  pickTab = "merit";
  pickOpen = false;
  merit: any = {
    merit: { rows: [], total: 0, page: 1, pages: 0, loading: false },
    participants: { rows: [], total: 0, page: 1, pages: 0, loading: false },
    added: { rows: [], total: 0, page: 1, pages: 0, loading: false },
  };
  meritYear = "";
  meritBusy = false;
  viewerDocs: { key: string; label: string; path: string | null }[] = [];
  viewerIndex = 0;
  viewerSrc: SafeUrl | SafeResourceUrl | null = null;
  viewerKind = "pdf";
  viewerLoading = false;
  viewerError = "";
  rejectDialogVisible = false;
  rejectingStudent: any = null;
  rejectionReason = "";
  rejecting = false;
  issoMenuId: number | null = null;
  viewerMenuOpen = false;
  searchText = "";
  statusFilter = "";
  readonly statusFilters = [
    { value: "", label: "All" },
    { value: "not_started", label: "Not started" },
    { value: "in_progress", label: "In progress" },
    { value: "ready", label: "Ready for review" },
    { value: "resubmitted", label: "Resubmitted" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ];
  private searchTimer: any;
  private listRequest = 0;
  approveDialogVisible = false;
  approvingStudent: any = null;
  paymentReference = "";
  approving = false;
  viewerStudent: any = null;
  viewerTab: "details" | "docs" = "docs";
  enrollDetails: any = null;
  enrollLoading = false;
  enrollError = "";
  readonly enrollFields = [
    ["studentName", "Student name"],
    ["fatherName", "Father's name"],
    ["motherName", "Mother's name"],
    ["dateOfBirth", "Date of birth"],
    ["gender", "Gender"],
    ["ageRange", "Age group"],
    ["aadharNo", "Aadhaar number"],
    ["passport", "Passport number"],
    ["phone", "Phone"],
    ["studentAddress", "Permanent address"],
    ["admissionNoYear", "Admission no. and year"],
    ["schoolJoinDate", "Date of joining school"],
    ["studyingYear", "Class studying"],
    ["studyingLastYear", "Class studied last year"],
    ["sgfiRegNo", "Last year SGFI reg. no."],
    ["personalMark1", "Identification mark 1"],
    ["personalMark2", "Identification mark 2"],
    ["tshirtSize", "T-shirt size"],
    ["trackSuitSize", "Track suit size"],
  ];

  /* The kit sizes are stored as labels; the chest measurement is what makes
     them mean something to whoever places the order. Mirrors the school form. */
  private readonly KIT_CHEST: { [size: string]: number } = {
    XS: 34, S: 36, M: 38, L: 40, XL: 42, XXL: 44,
  };

  isKitField(key: string): boolean {
    return key === "tshirtSize" || key === "trackSuitSize";
  }

  /** "M" reads as `M - 38"` wherever a kit size is shown. */
  kitSize(value: string): string {
    const v = String(value || "").trim().toUpperCase();
    return this.KIT_CHEST[v] ? v + ' - ' + this.KIT_CHEST[v] + '"' : (value || "");
  }
  private viewerCache: { [path: string]: { url: string; kind: string } } = {};

  constructor(
    public pdf: PdfDownloadService,
    private confirmation: ConfirmationService,
    private issoUtilService: IssoUtilService,
    private sgfiEntriesService: SgfiEntriesService,
    private messageService: MessageService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private meritService: ReportMeritService,
    private sanitizer: DomSanitizer,
    private sgfiEventsService: SgfiEventsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isAddStudent = true;
    this.loadInitialData();
    this.loadGame();
    this.baseUrl = environment.baseUrl;
    const routeData = this.route.snapshot.data;

    this.isAddStudent = routeData["isAddStudent"];
    this.eventScoped = !!routeData["eventScoped"];
    this.isViewStudent = routeData["isViewStudent"];
    this.isShowPayment = routeData["isShowPayment"];
    this.makeEmptyForm();

    if (this.isAddStudent) {
      this.loadMeritStudents();
    }

    // Inside an event the four category filters are not a choice: the event is
    // the choice. It otherwise runs exactly as View Student does.
    if (this.eventScoped) {
      const eventId = Number(this.route.snapshot.paramMap.get("eventId"));
      this.isViewStudent = true;
      this.gameReadble = true;
      this.ageReadble = true;
      this.genderReadble = true;
      this.sgfiEventsService.get(eventId).pipe(takeUntil(this.destroy$)).subscribe(
        (ev) => {
          this.event = ev;
          this.eventTitle =
            "U-" + ev.ageRange + " " + (ev.gender === "2" ? "Girls" : "Boys") + " " + (ev.gameName || "");
          this.yearvalue = ev.year;
          this.selectedYear = ev.year;
          this.gameId = String(ev.gameId);
          this.selectedAge = ev.ageRange;
          this.genderVal = ev.gender;
          this.selectedGender = ev.gender;
          this.showEnroolledStudent();
          this.meritSides = ["merit", "participants", "added"];
          this.loadMeritStudents();
          this.meritService.getAmountData().pipe(takeUntil(this.destroy$)).subscribe(
            (amt: any) => {
              if (Array.isArray(amt) && amt.length) this.standardFee = String(amt[0].amount || "");
            },
            () => { /* The placeholder falls back to naming no figure. */ },
          );
        },
        () => { this.error = "Could not load this event."; },
      );
      return;
    }

    // View Student opens on the whole of the current year rather than on an
    // empty screen that only fills once four dropdowns have been chosen.
    if (this.isViewStudent) {
      this.yearvalue = this.currentAcademicYear();
      this.selectedYear = this.yearvalue;
      this.gameReadble = true;
      this.ageReadble = true;
      this.genderReadble = true;
      this.showEnroolledStudent();
    }
  }

  /** Academic year runs June-May, matching the server. */
  currentAcademicYear() {
    const now = new Date();
    const y = now.getFullYear();
    return now.getMonth() + 1 >= 6 ? y + "-" + (y + 1) : y - 1 + "-" + y;
  }

  loadInitialData() {
    this.yearOptions = this.issoUtilService.setYear();
    this.ageOptions = this.issoUtilService.setAge();
    this.genderOptions = this.issoUtilService.setGender();
  }
  loadGame() {
    this.sgfiEntriesService.getRootGameList().pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          this.rootGameServicData = response;
          this.rootGameData = this.rootGameServicData;
          this.gameOptions = [];
          this.gameOptions.push({
            label: "Please select",
            value: "",
          });
          this.rootGameData.forEach((element) => {
            const gameIdAndName =
              element.gameId + "," + element.gameName + "," + element.gameType;
            this.gameOptions.push({
              label: element.gameName,
              value: gameIdAndName,
            });
          });
        } else {
        }
      },
      (error) => {
        //this.errorAlert =true;
      }
    );
  }
  loadGameChange(gameData) {
    this.enrolledStudentRecordLength = 0;
    const gameval = gameData.value;
    this.gameArray = gameval.split(",");
    this.gameId = this.gameArray[0];
    this.gameName = this.gameArray[1];
    this.gameType = this.gameArray[2];
    if (this.isShowPayment) {
      this.getPaymentSheetData();
    } else if (this.isViewStudent) {
      this.selectedSubGame = "";
      this.subGameReadable = false;
      this.ageReadble = true;
      this.genderReadble = true;
      this.reloadFromFirstPage();
    } else {
      this.selectedAge = "";
      this.selectedGender = "";
      this.selectedSubGame = "";
      this.selectedSchool = "";
      this.subGameReadable = false;
      this.ageReadble = false;
      this.genderReadble = false;
      this.schoolReadble = false;
      this.alreadyAddedStudentList = [];
      this.studentData = [];
      this.studentRecordLength = 0;
      if (gameData.value != "") {
        // if(this.gameType == 'Both') {
        //   this.ageReadble = false;
        //   this.loadSubGameData();
        // } else {
        this.ageReadble = true;
        this.selectedSubGame = "";
        this.subGameReadable = false;
        // }
      } else {
        this.selectedAge = "";
        this.selectedSchool = "";
        this.selectedGender = "";
        this.selectedSubGame = "";
        this.ageReadble = false;
        this.genderReadble = false;
        this.subGameReadable = false;
        this.schoolReadble = false;
      }
      this.reloadMerits();
    }
  }
  confirmStatusChange(student) {
    const approving = student.issoadminstatus != "1";
    this.confirmation.confirm({
      key: "confirm-isso-status",
      icon: "pi pi-info-circle",
      message: approving
        ? "Are you sure you want to approve " + student.studentName + " (" + student.gameName + ") for SGFI?"
        : "Are you sure you want to move " + student.studentName + " (" + student.gameName + ") back to pending?",
      accept: () => this.changeEventStatus(student, student.issoadminstatus),
    });
  }
  openRejectDialog(student) {
    this.rejectingStudent = student;
    this.rejectionReason = "";
    this.rejectDialogVisible = true;
  }
  submitRejection() {
    const reason = this.rejectionReason.trim();
    if (!this.rejectingStudent || reason.length < 3 || reason.length > 1000 || this.rejecting) return;
    this.rejecting = true;
    this.changeEventStatus(this.rejectingStudent, "2", reason);
  }
  issoState(student): string {
    if (student.issoadminstatus == "1") return "approved";
    if (student.issoadminstatus == "2") return "rejected";
    return this.canApprove(student) ? "pending" : "awaiting";
  }
  issoLabel(student): string {
    const labels: { [state: string]: string } = { approved: "Approved", rejected: "Rejected", pending: "Pending", awaiting: "Awaiting school" };
    return labels[this.issoState(student)];
  }
  toggleIssoMenu(student) {
    this.issoMenuId = this.issoMenuId === student.id ? null : student.id;
  }
  @HostListener("document:click")
  closeIssoMenu() {
    this.issoMenuId = null;
    this.viewerMenuOpen = false;
  }
  schoolProgress(student): string {
    const done = [student.isForm, student.isDoc, student.isPaid].filter((v) => v == "1").length;
    if (done === 3) return student.resubmitted ? "resubmitted" : "done";
    return done === 0 ? "none" : "partial";
  }
  schoolProgressLabel(student): string {
    const labels: { [state: string]: string } = { done: "Submitted", resubmitted: "Resubmitted", partial: "In progress", none: "Not started" };
    return labels[this.schoolProgress(student)];
  }
  get resubmission() {
    return this.enrollDetails && this.enrollDetails.resubmission;
  }
  /** The value before the rejection, or undefined when the school left the field alone. */
  previousValue(key: string) {
    const r = this.resubmission;
    const hit = r && r.changedFields && r.changedFields.find((f) => f.key === key);
    return hit ? hit.previous : undefined;
  }
  docChanged(key: string): boolean {
    const r = this.resubmission;
    return !!(r && r.changedDocs && r.changedDocs.some((d) => d.key === key));
  }
  resubmissionChanges(): string[] {
    const r = this.resubmission;
    if (!r || !r.changedFields || !r.changedDocs) return [];
    const fieldLabel = (k) => (this.enrollFields.find((f) => f[0] === k) || [k, k])[1];
    const docLabel = (k) => (this.viewerDocs.find((d) => d.key === k) || { label: k }).label;
    return r.changedFields.map((f) => fieldLabel(f.key)).concat(r.changedDocs.map((d) => docLabel(d.key)));
  }
  canReject(student): boolean {
    return student.issoadminstatus == "0" && student.isPaid == "1";
  }
  canApprove(student): boolean {
    return student.isForm == "1" && student.isDoc == "1";
  }
  missingDocs(student): string[] {
    const required = [
      ["birthCertificate", "Birth Certificate"],
      ["studentBonafide", "Bonafide"],
      ["studentGovDoc", "Government ID"],
      ["lastYearmarkSheet", "Last Year Mark Sheet"],
    ];
    return required.filter(([key]) => !student[key]).map(([, label]) => label);
  }
  confirmMoveToPending(student) {
    this.confirmation.confirm({
      key: "confirm-isso-status",
      icon: "pi pi-info-circle",
      message: "Are you sure you want to move " + student.studentName + " (" + student.gameName + ") back to pending?",
      accept: () => this.changeEventStatus(student, "1"),
    });
  }
  openApproveDialog(student) {
    this.approvingStudent = student;
    this.paymentReference = "";
    this.approveDialogVisible = true;
  }
  submitApproval() {
    const student = this.approvingStudent;
    const reference = this.paymentReference.trim();
    if (!student || this.approving || !this.canApprove(student)) return;
    if (student.isPaid != "1" && (reference.length < 3 || reference.length > 200)) return;
    this.approving = true;
    this.changeEventStatus(student, "0", "", student.isPaid == "1" ? "" : reference);
  }
  changeEventStatus(student, staus, rejectionReason = "", paymentReference = "") {
    const formData = new FormData();
    if (paymentReference) formData.append("paymentReference", paymentReference);
    if (staus == "2") {
      formData.append("issoadminstatus", "2");
      formData.append("rejectionReason", rejectionReason);
    } else if (staus == "1") {
      formData.append("issoadminstatus", "0");
    } else {
      formData.append("issoadminstatus", "1");
    }
    // Scope the flip to the row on screen; without these the API falls back to
    // legacy behaviour and approves every sport/year the student has.
    const studentId = student.sId;
    formData.append("gameId", student.gameId);
    formData.append("schoolId", student.schoolId);
    formData.append("year", this.yearvalue);
    this.sgfiEntriesService.changeIssoStatus(studentId, formData).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        if (res.status === "success") {
          this.messageService.add({
            key: "custom",
            severity: "success",
            summary: "Data Updated Successfully",
          });
        } else {
          this.messageService.add({
            key: "custom",
            severity: "success",
            summary: "Data Updated Successfully",
          });
        }
        this.display = false;
        this.rejectDialogVisible = false;
        this.rejecting = false;
        this.rejectingStudent = null;
        this.approveDialogVisible = false;
        this.approving = false;
        this.approvingStudent = null;
        this.showEnroolledStudent();
        //this.getEventData();
      },
      (error) => {
        this.error = error;
        this.rejecting = false;
        this.approving = false;
        this.messageService.add({
          key: "custom",
          severity: "error",
          summary: (error && error.errorDesc) || "Could not change the status.",
        });
      }
    );
  }
  exportAsGameXLSX() {
    this.meritService.exportAsExcelFile(
      this.sgfiPaymentData,
      "sgfi-payment-sheet"
    );
  }
  getPaymentSheetData() {
    this.sgfiEntriesService
      .getPaymentSheetData(this.yearvalue, this.gameId)
      .pipe(takeUntil(this.destroy$)).subscribe(
        (response) => {
          if (response !== "") {
            this.sgfiPaymentData = response;
            this.sgfiPaymentDataLength = this.sgfiPaymentData.length;
            this.gameconsolitedArray = [];
            if (this.sgfiPaymentData.length > 1) {
              this.isPaymentData = true;
            } else {
              this.isPaymentData = false;
              this.messageService.add({
                key: "custom",
                severity: "error",
                summary: "Data not found",
              });
            }
          } else {
          }
        },
        (error) => {
          //this.errorAlert =true;
        }
      );
  }
  /** Document viewer: every file for the student in one modal, stepped through in place. */
  showDialog(student) {
    this.closeViewer();
    this.dialogTitle = student.studentName;
    this.viewerStudent = student;
    this.loadEnrollDetails(student);
    const rel = (v) => (v == null || v === "" ? null : "upload/sgfi/" + v);
    this.viewerDocs = [
      { key: "birthCertificate", label: "Birth Certificate", path: rel(student.birthCertificate) },
      { key: "studentBonafide", label: "Bonafide", path: rel(student.studentBonafide) },
      { key: "studentGovDoc", label: "Government ID", path: rel(student.studentGovDoc) },
      { key: "lastYearmarkSheet", label: "Last Year Mark Sheet", path: rel(student.lastYearmarkSheet) },
      { key: "studentPhoto", label: "Photo", path: rel(student.studentPhoto) },
      { key: "studentSign", label: "Student Sign", path: rel(student.studentSign) },
    ];
    this.display = true;
    this.showDetails();
  }
  showDetails() {
    this.viewerTab = "details";
    this.viewerIndex = -1;
  }
  private loadEnrollDetails(student) {
    this.enrollDetails = null;
    this.enrollError = "";
    this.enrollLoading = true;
    this.sgfiEntriesService
      .getEnrollDetails(student.studentId, student.schoolId, student.gameId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (details) => {
          if (this.viewerStudent !== student) return;
          this.enrollLoading = false;
          this.enrollDetails = details;
          const photo = this.viewerDocs.find((d) => d.key === "studentPhoto");
          if (photo && !photo.path && details && details.studentPhoto) {
            photo.path = "upload/sgfi/" + details.studentPhoto;
            student.studentPhoto = details.studentPhoto;
          }
        },
        () => {
          if (this.viewerStudent !== student) return;
          this.enrollLoading = false;
          this.enrollError = "Could not load the submitted details.";
        }
      );
  }
  showDoc(i: number) {
    const doc = this.viewerDocs[i];
    this.viewerTab = "docs";
    this.viewerIndex = i;
    this.viewerError = "";
    this.viewerSrc = null;
    if (!doc || !doc.path) return;
    const cached = this.viewerCache[doc.path];
    if (cached) {
      this.setViewerSrc(cached.url, cached.kind);
      return;
    }
    this.viewerLoading = true;
    const path = doc.path;
    this.pdf.fetchBlob(path).pipe(takeUntil(this.destroy$)).subscribe(
      async (blob: Blob) => {
        const mime = await this.sniffType(blob);
        if (!mime) {
          if (this.viewerDocs[this.viewerIndex] && this.viewerDocs[this.viewerIndex].path === path) {
            this.viewerLoading = false;
            this.viewerError = "This file is not a PDF or image the browser can show. Use Open in new tab to download it.";
          }
          return;
        }
        const kind = mime === "application/pdf" ? "pdf" : "image";
        const url = URL.createObjectURL(blob.type === mime ? blob : new Blob([blob], { type: mime }));
        this.viewerCache[path] = { url, kind };
        // A slow response for a document the admin has already moved past is dropped.
        if (this.viewerDocs[this.viewerIndex] && this.viewerDocs[this.viewerIndex].path === path) {
          this.viewerLoading = false;
          this.setViewerSrc(url, kind);
        }
      },
      () => {
        this.viewerLoading = false;
        this.viewerError = "Could not load this document.";
      }
    );
  }
  private sniffType(blob: Blob): Promise<string | null> {
    return new Promise((resolve) => {
      const r = new FileReader();
      r.onload = () => {
        const b = new Uint8Array(r.result as ArrayBuffer);
        const ascii = (from: number, to: number) => String.fromCharCode(...Array.from(b.subarray(from, to)));
        if (ascii(0, 4) === "%PDF") resolve("application/pdf");
        else if (b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff) resolve("image/jpeg");
        else if (b[0] === 0x89 && ascii(1, 4) === "PNG") resolve("image/png");
        else if (ascii(0, 3) === "GIF") resolve("image/gif");
        else if (ascii(0, 4) === "RIFF" && ascii(8, 12) === "WEBP") resolve("image/webp");
        else resolve(null);
      };
      r.onerror = () => resolve(null);
      r.readAsArrayBuffer(blob.slice(0, 16));
    });
  }
  private setViewerSrc(url: string, kind: string) {
    this.viewerLoading = false;
    this.viewerKind = kind;
    this.viewerSrc =
      kind === "pdf"
        ? this.sanitizer.bypassSecurityTrustResourceUrl(url + "#toolbar=1&view=FitH")
        : this.sanitizer.bypassSecurityTrustUrl(url);
  }
  stepDoc(dir: number) {
    const n = this.viewerDocs.length;
    for (let k = 1; k <= n; k++) {
      const from = this.viewerIndex < 0 ? (dir > 0 ? -1 : n) : this.viewerIndex;
      const i = (from + dir * k + n) % n;
      if (this.viewerDocs[i].path) return this.showDoc(i);
    }
  }
  isOverdue(student) {
    return !!student.decisionBy && new Date(student.decisionBy).getTime() < Date.now();
  }
  get viewerCount() {
    return this.viewerDocs.filter((d) => d.path).length;
  }
  get viewerPosition() {
    return this.viewerDocs.slice(0, this.viewerIndex + 1).filter((d) => d.path).length;
  }
  openViewerInTab() {
    const doc = this.viewerDocs[this.viewerIndex];
    if (doc && doc.path) this.pdf.openFile(doc.path);
  }
  closeViewer() {
    Object.keys(this.viewerCache).forEach((k) => URL.revokeObjectURL(this.viewerCache[k].url));
    this.viewerCache = {};
    this.viewerDocs = [];
    this.viewerSrc = null;
    this.viewerError = "";
    this.viewerLoading = false;
    this.viewerStudent = null;
    this.enrollDetails = null;
    this.viewerMenuOpen = false;
    this.viewerTab = "docs";
  }
  @HostListener("document:keydown", ["$event"])
  onViewerKey(e: KeyboardEvent) {
    if (!this.display) return;
    if (e.key === "ArrowRight") this.stepDoc(1);
    else if (e.key === "ArrowLeft") this.stepDoc(-1);
  }
  loadSubGameData() {
    this.sgfiEntriesService.getSubGameList(this.gameId).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          this.subGameServicData = response;
          this.subGameData = this.subGameServicData;
          this.subgameOptions = [];
          this.subGameData.forEach((element) => {
            const gameIdAndName =
              element.id + "," + element.subGameName + "," + element.gameType;
            this.subgameOptions.push({
              label: element.subGameName,
              value: gameIdAndName,
            });
          });
          this.subGameReadable = true;
        } else {
        }
      },
      (error) => {
        //this.errorAlert =true;
      }
    );
  }
  onViewStudentYearChange(event) {
    this.yearvalue = event.value;
  }
  onyeareChange(event) {
    this.yearvalue = event.value;
    this.selectedGame = "";
    this.selectedAge = "";
    this.selectedSchool = "";
    this.selectedGender = "";
    this.selectedSubGame = "";
    this.ageReadble = false;
    this.genderReadble = false;
    this.subGameReadable = false;
    this.gameReadble = false;
    this.schoolReadble = false;
    this.schoolReadble = false;
    this.alreadyAddedStudentList = [];
    this.studentRecordLength = 0;
    this.enrolledStudentRecordLength = 0;
    if (this.yearvalue) {
      this.gameReadble = true;
    }
    if (this.isViewStudent) {
      // Year alone is a complete filter here; the rest only narrow it.
      this.gameId = "";
      this.genderVal = "";
      this.ageReadble = true;
      this.genderReadble = true;
      this.reloadFromFirstPage();
    }
    if (this.isAddStudent) {
      this.gameId = "";
      this.reloadMerits();
    }
  }
  loadAgeChange(ageData) {
    this.selectedGender = "";
    this.selectedSchool = "";
    this.selectedGender = "";
    this.genderReadble = false;
    this.genderReadble = false;
    this.schoolReadble = false;
    this.alreadyAddedStudentList = [];
    this.studentRecordLength = 0;
    this.enrolledStudentRecordLength = 0;
    if (ageData.value != "") {
      this.genderReadble = true;
    }
    if (this.isViewStudent) {
      this.genderReadble = true;
      this.reloadFromFirstPage();
    }
    if (this.isAddStudent) {
      this.reloadMerits();
    }
  }
  loadGenderChange(gender) {
    this.getSchoolList = [];
    if (this.subGameIdArray.length > 0) {
      this.subGameId = this.subGameIdArray.toString();
    } else {
      this.subGameId = "N";
    }
    this.genderVal = gender.value;
    if (this.isAddStudent) {
      this.reloadMerits();
    }
    this.subGameIdArray = [];
    this.subGameNameArray = [];
    if (this.genderVal !== "") {
      this.getSchoolList.push(
        this.yearvalue,
        this.gameId,
        this.selectedAge,
        this.genderVal,
        this.gameType
      );
      this.schoolReadble = true;
      if (this.isAddStudent) {
        if (this.subGameVal && this.gameType == "Both") {
          this.subGameVal.forEach((element) => {
            if (this.subGameIdArray.some((x) => x == element.split(",")[0])) {
            } else {
              this.subGameIdArray.push(Number(element.split(",")[0]));
              this.subGameNameArray.push(element.split(",")[1]);
            }
          });
        }
        this.getSchools();
      } else {
        this.showEnroolledStudent();
      }
    } else if (this.isViewStudent) {
      this.reloadFromFirstPage();
    } else {
      this.schoolReadble = false;
      this.selectedSchool = "";
    }
  }
  /** A filter changed: results differ, so go back to the first page. */
  reloadFromFirstPage() {
    this.currentPage = 1;
    this.showEnroolledStudent();
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    this.showEnroolledStudent();
  }

  /** Page numbers to show: a window around the current page, never more than 5. */
  get pageNumbers(): number[] {
    const span = 5;
    let start = Math.max(1, this.currentPage - Math.floor(span / 2));
    const end = Math.min(this.totalPages, start + span - 1);
    start = Math.max(1, end - span + 1);
    const out = [];
    for (let i = start; i <= end; i++) out.push(i);
    return out;
  }

  get isFiltered(): boolean {
    return this.isViewStudent && (!!this.searchText.trim() || !!this.statusFilter);
  }
  onSearchChange() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      if (this.isAddStudent) { this.reloadMerits(); return; }
      this.currentPage = 1;
      this.showEnroolledStudent();
    }, 350);
  }
  setStatusFilter(value: string) {
    if (this.statusFilter === value) return;
    this.statusFilter = value;
    this.currentPage = 1;
    this.showEnroolledStudent();
  }
  showEnroolledStudent() {
    const formData = new FormData();
    // [year, gameId, age, gender] - any slot may be blank in View mode.
    const filters = this.isViewStudent
      ? [
          this.yearvalue || "",
          this.gameId || "",
          this.selectedAge || "",
          this.genderVal || "",
        ]
      : this.getSchoolList;
    formData.append("subGameId", JSON.stringify(this.subGameId || "N"));
    formData.append("getStudentData", JSON.stringify(filters));
    if (this.isViewStudent) {
      formData.append("page", String(this.currentPage));
      formData.append("pageSize", String(this.pageSize));
      formData.append("q", this.searchText.trim());
      formData.append("status", this.statusFilter);
    }
    this.isLoading = true;
    const request = ++this.listRequest;
    this.sgfiEntriesService
      .getEnrolledStudentData(formData)
      .pipe(takeUntil(this.destroy$)).subscribe(
        (response) => {
          // Typing quickly fires several searches; only the latest may fill the table.
          if (request !== this.listRequest) return;
          this.isLoading = false;
          if (response === "" || response == null) return;
          // Paged requests answer { data, total }; the unpaged ones a bare array.
          const rows = response.data ? response.data : response;
          this.totalRecords = response.data ? response.total : rows.length;
          this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
          this.enrolledStudentData = rows;
          this.enrolledStudentRecordLength = rows.length;
          // Inside an event an empty list is the ordinary starting point, and
          // the screen says so properly. An error toast on arrival is noise.
          if (rows.length === 0 && !this.isFiltered && !this.eventScoped) {
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: "Data not found",
            });
          }
        },
        () => {
          this.isLoading = false;
          this.enrolledStudentRecordLength = 0;
          this.messageService.add({
            key: "custom",
            severity: "error",
            summary: "Could not load the student list",
          });
        }
      );
  }
  loadSubGameChange(subgame) {
    this.selectedAge = "";
    this.selectedGender = "";
    this.selectedSchool = "";
    this.genderReadble = false;
    this.ageReadble = false;
    this.schoolReadble = false;
    this.alreadyAddedStudentList = [];
    this.studentRecordLength = 0;
    this.subGameVal = subgame.value;
    if (this.subGameVal.length > 0) {
      this.ageReadble = true;
    } else {
      this.ageReadble = false;
    }
  }
  getSchools() {
    this.studentRecordLength = 0;

    // this.getAlreadyAddedData();
    const formData = new FormData();
    formData.append("getSchoolList", JSON.stringify(this.getSchoolList));
    formData.append("subGameId", JSON.stringify(this.subGameId));
    this.sgfiEntriesService.loadSchoolByGame(formData).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response !== "") {
          if (response[0].length > 0) {
            this.schoolReadble = true;
            this.schoolList = response[0];
            this.schoolOptions = [];
            this.schoolOptions.push({
              label: "Please Select",
              value: "",
            });
            this.schoolList.forEach((element) => {
              const schoolIdAndName =
                element.schoolId + "," + element.schoolName;
              this.schoolOptions.push({
                label: element.schoolName,
                value: schoolIdAndName,
              });
            });
          } else {
            this.schoolList = [];
            this.schoolReadble = false;
            this.selectedSchool = "";
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: "School not found",
            });
          }
          if (response[1].length > 0) {
            this.alreadyAddedStudentList = response[1];
            this.studentRecordLength = Object.keys(
              this.alreadyAddedStudentList
            ).length;
          }
        }
      },
      (error) => {
        //this.errorAlert =true;
      }
    );
  }
  loadSchoolChange(schoolData) {
    const schoolval = schoolData.value.split(",")[0];
    this.schoolId = schoolData.value.split(",")[0];
    this.schoolName = schoolData.value.split(",")[1];
    this.studentDataArray = [];
    this.studentDataArray.push(
      this.yearvalue,
      this.gameId,
      this.selectedAge,
      this.genderVal,
      schoolval
    );
    const formData = new FormData();
    formData.append("studentData", JSON.stringify(this.studentDataArray));
    formData.append("subGameId", JSON.stringify(this.subGameId));
    if (schoolval !== "") {
      this.sgfiEntriesService.loadStudentData(formData).pipe(takeUntil(this.destroy$)).subscribe(
        (response) => {
          if (response.length > 0) {
            this.studentData = response;
            this.isShowStudent = true;
          } else {
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: "Data not found",
            });
          }
        },
        (error) => {
          //this.errorAlert =true;
        }
      );
    }
  }
  deleteStudent(studentId) {
    this.sgfiEntriesService.deleteStudent(studentId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        //  if (res.status !== 'error') {
        //    this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
        //  } else {
        this.messageService.add({
          key: "custom",
          severity: "success",
          summary: "Studnet Data Deleted Successfully",
        });
        this.getSchools();
        //  }
      },
      (error) => (this.error = error)
    );
  }
  addStudent(studentData) {
    let findElement = this.alreadyAddedStudentList.find(
      (el) => el.sId == studentData.sId
    );
    if (findElement) {
      this.alreadyExist = true;
      this.messageService.add({
        key: "custom",
        severity: "error",
        summary: "This studnet already exist in database",
      });
    } else {
      this.alreadyExist = false;
    }
    this.isDuplicate = false;
    if (this.sgfiStudentArray.length !== 20) {
      if (this.sgfiStudentArray.length > 0) {
        for (let i = 0; i < this.sgfiStudentArray.length; i++) {
          if (this.sgfiStudentArray[i].studentId == studentData.sId) {
            this.isDuplicate = true;
            break;
          } else {
            this.isDuplicate = false;
          }
        }
      }

      if (this.isDuplicate) {
        this.messageService.add({
          key: "custom",
          severity: "error",
          summary: "This studnet already exist!",
        });
      } else if (!this.alreadyExist) {
        this.sgfiStudentArray.push({
          studentId: studentData.sId,
          studentName: studentData.studentName,
          gameId: this.gameId,
          agerange: this.selectedAge,
          genderId: this.genderVal,
          schoolId: this.schoolId,
          yearVal: this.yearvalue,
          gameName: this.gameName,
          subGameId: studentData.subgameId.replaceAll(",", " "),
          subGameName: studentData.subGameName,
          schoolName: this.schoolName,
        });
      }
    } else {
      this.messageService.add({
        key: "custom",
        severity: "error",
        summary: "Maximum 20 student only!",
      });
    }
  }
  removeStudnetData(i: number): void {
    this.sgfiStudentArray.splice(i, 1);
  }
  confirmAddStudent() {
    if (event.defaultPrevented) return;
    event.preventDefault();
    this.confirmation.confirm({
      key: "confirm-add-student",
      icon: "pi pi-info-circle",
      message: "Are you sure to add student data?",
      accept: () => {
        this.saveSgfiStudentData();
      },
    });
  }
  confirmDeleteStudent(studentId) {
    if (event.defaultPrevented) return;
    event.preventDefault();
    this.confirmation.confirm({
      key: "confirm-delete-student",
      icon: "pi pi-info-circle",
      message: "Are you sure to delete studnet data?",
      accept: () => {
        this.deleteStudent(studentId);
      },
    });
  }
  saveSgfiStudentData() {
    this.saveSgfiStudentArray = [];
    for (let i = 0; i < this.sgfiStudentArray.length; i++) {
      this.saveSgfiStudentArray.push(
        this.sgfiStudentArray[i].studentId,
        this.sgfiStudentArray[i].gameId,
        this.sgfiStudentArray[i].agerange,
        this.sgfiStudentArray[i].genderId,
        this.sgfiStudentArray[i].schoolId,
        this.sgfiStudentArray[i].yearVal,
        this.sgfiStudentArray[i].subGameId
      );
    }

    const formData = new FormData();
    formData.append(
      "sgfiStudentArray",
      JSON.stringify(this.saveSgfiStudentArray)
    );

    this.sgfiEntriesService.saveSgfiStudentData(formData).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        if (res.status === "error") {
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: "Validation failed",
          });
        } else {
          this.messageService.add({
            key: "custom",
            severity: "success",
            summary: "Studnet Data Added Successfully",
          });
          // Inside an event the filters are the event; resetting them would
          // empty the screen the admin is standing on.
          if (this.eventScoped) {
            this.reloadMerits();
            this.showEnroolledStudent();
            return;
          }
          const year = this.yearvalue;
          this.makeEmptyForm();
          if (this.isAddStudent) {
            this.yearvalue = year;
            this.selectedYear = year;
            this.gameReadble = !!year;
            this.gameId = "";
            this.reloadMerits();
          }
        }
      },
      (error) => (this.error = error)
    );
    if (this.error) {
      this.messageService.add({
        key: "custom",
        severity: "error",
        summary: "Error occured",
      });
    }
  }
  /** Blank year: the server picks the latest year that has merits. */
  loadMeritStudents() {
    this.meritSides.forEach((side) => this.loadMeritSide(side));
  }
  loadMeritSide(side) {
    const state = this.merit[side];
    const formData = new FormData();
    formData.append(
      "filters",
      JSON.stringify([
        this.yearvalue || "",
        this.gameId || "",
        this.selectedAge || "",
        this.selectedGender || "",
      ])
    );
    formData.append("source", side);
    formData.append("q", (this.eventScoped ? this.pickSearch : this.searchText).trim());
    formData.append("page", String(state.page));
    formData.append("pageSize", String(this.pageSize));
    state.loading = true;
    this.sgfiEntriesService.loadCandidates(formData).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        state.loading = false;
        state.rows = response.data || [];
        state.total = response.total || 0;
        state.pages = Math.ceil(state.total / this.pageSize);
        // A delete can empty the last page; step back rather than show nothing.
        if (state.page > 1 && state.rows.length === 0) {
          state.page = Math.max(1, state.pages);
          this.loadMeritSide(side);
          return;
        }
        this.meritYear = response.year;
        if (!this.yearvalue && response.year) {
          this.yearvalue = response.year;
          this.selectedYear = response.year;
          this.gameReadble = true;
        }
      },
      () => {
        state.loading = false;
        state.rows = [];
        state.total = 0;
        state.pages = 0;
        this.messageService.add({
          key: "custom",
          severity: "error",
          summary: "Could not load merit students",
        });
      }
    );
  }
  /** The event has no entries at all - not merely none matching a filter. */
  get eventEmpty(): boolean {
    return this.eventScoped && !this.isLoading && !this.isFiltered && this.totalRecords === 0;
  }

  /** What an empty fee override will actually charge. */
  get feePlaceholder(): string {
    return this.standardFee ? "Standard fee (₹" + this.standardFee + ")" : "Standard fee";
  }

  get eventImage(): string { return sportImage(this.event && this.event.gameName); }

  longDate(iso: string): string { return longDate(iso); }

  openEventSettings() {
    if (!this.event) return;
    this.eventForm = {
      lastDate: this.event.lastDate || "",
      reportingDate: this.event.reportingDate || "",
      venue: this.event.venue || "",
      description: this.event.description || "",
      feeOverride: this.event.feeOverride || "",
    };
    this.eventError = "";
    this.eventEditOpen = true;
  }

  saveEventSettings() {
    if (this.eventSaving || !this.event) return;
    if (!this.eventForm.lastDate) { this.eventError = "A last date to apply is needed."; return; }
    this.eventSaving = true;
    this.eventError = "";
    // The category and season are sent back unchanged - the server refuses to
    // re-home an event, which would move every entry under it.
    this.sgfiEventsService.save({
      id: this.event.id,
      year: this.event.year,
      gameId: this.event.gameId,
      ageRange: this.event.ageRange,
      gender: this.event.gender,
      ...this.eventForm,
    } as any).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.eventSaving = false;
        if (!res || res.status !== "success") { this.eventError = "Could not save the event. Please try again."; return; }
        this.event = { ...this.event, ...this.eventForm };
        this.eventEditOpen = false;
        this.messageService.add({ key: "custom", severity: "success", summary: "Event updated" });
      },
      (err) => {
        this.eventSaving = false;
        this.eventError = (err && err.error && err.error.error) || "Could not save the event. Please try again.";
      },
    );
  }

  removeEvent() {
    if (!this.event || this.eventSaving) return;
    this.confirmation.confirm({
      key: "confirm-delete-student",
      icon: "pi pi-exclamation-triangle",
      message: this.totalRecords
        ? `${this.totalRecords} student${this.totalRecords === 1 ? "" : "s"} entered under this event will be removed with it. Delete ${this.eventTitle}?`
        : `Delete ${this.eventTitle}?`,
      accept: () => {
        this.eventSaving = true;
        this.eventError = "";
        this.sgfiEventsService.remove(this.event.id).pipe(takeUntil(this.destroy$)).subscribe(
          () => {
            this.eventSaving = false;
            this.eventEditOpen = false;
            this.router.navigate(["/admin/sgfi-events"]);
          },
          (err) => {
            this.eventSaving = false;
            // The server refuses outright once a school has paid.
            this.eventError = (err && err.error && err.error.error) || "Could not delete this event.";
          },
        );
      },
    });
  }

  openPicker() {
    this.pickSearch = "";
    this.pickTab = "merit";
    this.reloadMerits();
    this.pickOpen = true;
  }

  onPickSearch() {
    if (this.pickSearchTimer) clearTimeout(this.pickSearchTimer);
    this.pickSearchTimer = setTimeout(() => this.reloadMerits(), 300);
  }

  reloadMerits() {
    this.meritSides.forEach((side) => (this.merit[side].page = 1));
    this.loadMeritStudents();
  }
  goToMeritPage(side, page: number) {
    const state = this.merit[side];
    if (page < 1 || page > state.pages || page === state.page) return;
    state.page = page;
    this.loadMeritSide(side);
  }
  meritPageNumbers(side): number[] {
    const { page, pages } = this.merit[side];
    const span = 5;
    let start = Math.max(1, page - Math.floor(span / 2));
    const end = Math.min(pages, start + span - 1);
    start = Math.max(1, end - span + 1);
    const out = [];
    for (let i = start; i <= end; i++) out.push(i);
    return out;
  }
  rankLabel(rank) {
    return ({ 1: "1st", 2: "2nd", 3: "3rd" } as any)[rank] || "-";
  }
  isStudentAdded(student) {
    return (
      this.sgfiStudentArray.some((s) => s.studentId == student.sId && s.gameId == this.gameId) ||
      (this.alreadyAddedStudentList || []).some((s) => s.sId == student.sId)
    );
  }
  addMeritStudent(student) {
    const formData = new FormData();
    formData.append(
      "sgfiStudentArray",
      JSON.stringify([
        student.sId,
        student.gameId,
        student.ageRange,
        student.gender,
        student.schoolId,
        this.meritYear,
        String(student.subgameId || "").replace(/,/g, " "),
      ])
    );
    this.meritBusy = true;
    this.sgfiEntriesService.saveSgfiStudentData(formData).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        this.meritBusy = false;
        this.messageService.add({
          key: "custom",
          severity: "success",
          summary: student.studentName + " added to SGFI",
        });
        this.loadMeritStudents();
        // The picker and the entries table are two views of the same list; the
        // table was only ever refreshed by the bulk add form, so adding from
        // here left it stale until a reload.
        if (this.eventScoped || this.isViewStudent) this.showEnroolledStudent();
      },
      () => {
        this.meritBusy = false;
        this.messageService.add({
          key: "custom",
          severity: "error",
          summary: "Could not add the student",
        });
      }
    );
  }
  removeMeritStudent(student) {
    this.confirmation.confirm({
      key: "confirm-delete-student",
      icon: "pi pi-info-circle",
      message: "Remove " + student.studentName + " from SGFI " + this.meritYear + "?",
      accept: () => {
        this.meritBusy = true;
        this.sgfiEntriesService.deleteStudent(student.sgfiEntryId).pipe(takeUntil(this.destroy$)).subscribe(
          () => {
            this.meritBusy = false;
            this.messageService.add({
              key: "custom",
              severity: "success",
              summary: student.studentName + " removed from SGFI",
            });
            this.loadMeritStudents();
            if (this.eventScoped || this.isViewStudent) this.showEnroolledStudent();
          },
          (err) => {
            this.meritBusy = false;
            this.messageService.add({
              key: "custom",
              severity: "error",
              summary: (err && err.error && err.error.error) || "Could not remove the student",
            });
          }
        );
      },
    });
  }
  makeEmptyForm() {
    this.saveSgfiStudentArray = [];
    this.sgfiStudentArray = [];
    this.selectedGame = "";
    this.selectedAge = "";
    this.selectedSchool = "";
    this.selectedGender = "";
    this.selectedSubGame = "";
    this.selectedYear = "";
    this.yearvalue = "";
    this.ageReadble = false;
    this.genderReadble = false;
    this.subGameReadable = false;
    this.gameReadble = false;
    this.schoolReadble = false;
    this.schoolReadble = false;
    this.isShowStudent = false;
    this.studentRecordLength = 0;
  }
  ngOnDestroy() {
    clearTimeout(this.searchTimer);
    this.closeViewer();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
